<rt-box
  variant="vertical"
  [rtProtectedControl]="workModelControl()"
  [class.invalid]="showInvalid && !readOnly()"
>
  <div layout layout-space-between margin-bottom>
    <div>
      <rt-heading variant="heading large block">
        {{ translations.heading | translate }}
        @if (showRequiredBadge && !readOnly()) {
          <span class="badge-required">*</span>
        }
      </rt-heading>
      <span>
        {{ translations.subheading | translate }}
      </span>
    </div>
  </div>

  <div class="item-list">
    <rt-work-model-item
      [title]="'app.offer_form.work_model_section.on_site.title' | translate"
      [description]="'app.offer_form.work_model_section.on_site.description' | translate"
      [icon]="'domain'"
      [isSelected]="onSiteControl.value"
      [readOnly]="readOnly()"
      (click)="!readOnly() && select(onSiteControl)"
      (select)="!readOnly() && select(onSiteControl)"
    />
    <rt-work-model-item
      [title]="'app.offer_form.work_model_section.remote.title' | translate"
      [description]="'app.offer_form.work_model_section.remote.description' | translate"
      [icon]="'nav-careershub'"
      [isSelected]="remoteControl.value"
      [readOnly]="readOnly()"
      (click)="!readOnly() && select(remoteControl)"
      (select)="!readOnly() && select(remoteControl)"
    />
    <rt-work-model-item
      [title]="'app.offer_form.work_model_section.hybrid.title' | translate"
      [description]="'app.offer_form.work_model_section.hybrid.description' | translate"
      [icon]="'hybrid'"
      [isSelected]="hybridControl.value"
      [readOnly]="readOnly()"
      (click)="!readOnly() && select(hybridControl)"
      (select)="!readOnly() && select(hybridControl)"
    />
  </div>
</rt-box>
@if (viewContext() === WorkModelSectionViewContext.Job && showInvalid) {
  <span text-red padding-top-small-xx>{{
    'app.offer_form.errors_new_validation.work_model.required' | translate
  }}</span>
}
